// extracted by mini-css-extract-plugin
export default {"modal":"ModalWindow_modal__EZoW3","modalBody":"ModalWindow_modalBody__Slyfy","modalActions":"ModalWindow_modalActions__RuGGK"};